import { create } from 'apisauce';

const client = create({
	baseURL:'http://support.kalyanicrm.com/automates/',
	withCredentials: false,
});

export default client;
